import { Box, Grid, Stack } from '@mui/material';
import { useDialog } from 'common/hooks/useDialog';
import { CashflowGuardianWidget } from 'components/cashflowGuardian/cashflowGuardianWidget/CashflowGuardianWidget';
import { ContactWidget } from 'components/ContactWidget/ContactWidget';
import { AvailableFunds } from 'components/HomePage/Dashboard/AvailableFunds';
import { Profile } from 'components/HomePage/Dashboard/Profile';
import { SpendingReportDialog, SpendingReportDialogProps } from 'components/spendingReport/SpendingReportDialog';
import { SpendingReportWidget } from 'components/spendingReport/SpendingReportWidget/SpendingReportWidget';
import { useState } from 'react';

import { FinoptioReportWidget } from '../../reports/finoptioReport/FinoptioReportWidget';
import { FintelligenceReportWidget } from '../../reports/fintelligenceReport/FintelligenceReportWidget';
import { styles } from './Dashboard.styles';

export const Dashboard: React.FC = () => {
  const [hasContact, setHasContact] = useState(false);

  const spendingReportDialog = useDialog<SpendingReportDialogProps, void>(SpendingReportDialog, {
    instanceId: 'spending-report',
    navigable: true,
  });

  const handleShowSpendingReportDialog = () => {
    spendingReportDialog.create({});
  };

  return (
    <Grid container direction="row" spacing={4}>
      <Grid item sm={6} xs={12}>
        <Stack height="100%" spacing={4}>
          <Profile />
        </Stack>
      </Grid>
      <Grid item sm={6} xs={12}>
        <Stack height="100%" spacing={4}>
          <FinoptioReportWidget />
          <FintelligenceReportWidget />
        </Stack>
      </Grid>
      <Grid item sm={6} xs={12}>
        <Stack height="100%" spacing={4}>
          <AvailableFunds />
          <CashflowGuardianWidget />
        </Stack>
      </Grid>
      <Grid item sm={6} xs={12}>
        <Box height="100%" onClick={handleShowSpendingReportDialog} sx={styles.clickableBox}>
          <SpendingReportWidget />
        </Box>
      </Grid>
      <Grid display={hasContact ? 'block' : 'none'} item sm={12} xs={12}>
        <Box height="100%">
          <ContactWidget onHasContact={() => setHasContact(true)} />
        </Box>
      </Grid>
    </Grid>
  );
};
